import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function AnalyticsTracker() {
  const location = useLocation()
  useEffect(() => {
    fetch("/api/website/analytics/beacon", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: location.pathname, referrer: document.referrer }),
    }).catch(() => {})
  }, [location.pathname])
  return null
}
